import {
  Button,
  Container,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core'
import Spinning from 'components/Common/Spinner/Spinning'
import { Section } from 'components/Layout/Section'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useAppRunningContext } from 'features/EmbeddedRh24/useAppRunningContext'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'
import { ProductName } from '../Common/ProductName/ProductName'
import './LandingPage.sass'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100vh',
    },
    appBar: {
      backgroundColor: theme.palette.background.default,
    },
    navbar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: theme.spacing(10),
      '& img': {
        width: '100%',
        // height: '100%',
        maxWidth: '120px',
        // maxHeight: '56px',
      },
    },
    navbarSection: {
      display: 'flex',
      gap: theme.spacing(1),
      '& button': {
        // color: theme.palette.primary.contrastText
      },
    },
    hero: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '1.5em',
      justifyContent: 'center',
      height: '100vh',
      ['& h3']: {
        fontSize: '3.0rem',
      },
    },
    productName: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    smartMetal: {
      marginTop: 'auto',
      width: '100%',
      textAlign: 'center',
      fontVariant: 'all-small-caps',
      display: 'block',
    },
    whiteSection: {
      backgroundColor: theme.palette.common.white,
      ['& img']: {
        maxHeight: '100%',
        maxWidth: '100%',
      },
    },
    footer: {
      textAlign: 'center',
      padding: theme.spacing(2),
    },
    fullWidth: {
      width: '100%',
    },
  })
)

const LandingPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { withinIframe } = useAppRunningContext()
  const { t } = useTranslation(['common'])
  const cn = useStyles()
  const userContext = useAppSelector(
    (state: RootAppState) => state.user.profile
  )

  const state = location.state

  useEffect(() => {
    if (withinIframe) {
      navigate('/login', { state })
    }
  }, [withinIframe, navigate, state])

  useEffect(() => {
    if (userContext) {
      navigate('/app')
    }
  }, [userContext, navigate])

  if (withinIframe) return <Spinning />

  return (
    <div>
      <div className={cn.hero}>
        <Section className={cn.productName}>
          <Container maxWidth="md">
            <ProductName />
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={() => navigate('/login', { state })}
            >
              {t('common:start-now')}
            </Button>
          </Container>
        </Section>
        <Button
          variant="text"
          className={cn.smartMetal}
          component="a"
          href="https://quotationfactory.com"
        >
          <Typography variant="h6">
            <strong>
              <LocalizedTypography
                translationKey="common:landing-page-hero-footer-call-to-action"
                translationDefaultValue="smart metal calculations, direct quotes and cam downloads, 24/7"
                component="p"
                className="hero-footer--call-to-action"
              />
            </strong>
          </Typography>
        </Button>
      </div>
    </div>
  )
}

export default LandingPage
